<template>
    <article class='xbed-oms-content'>
        <section class='xbed-sub-title'>
            <span>经营利润明细</span>
        </section>
        <section style='marginTop:20px'>
            <Form :model='chainReportDeatilData' ref='orderDetail'>
                <Row>
                    <Col span='8'>
                        <FormItem prop='' label='月份：' :label-width='120'>
                            <div>{{chainReportDeatilData.month}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='门店：' :label-width='120'>
                            <div>{{chainReportDeatilData.chainName}}</div>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span='8'>
                        <FormItem prop='' label='经营收入合计：' :label-width='120'>
                            <div>{{chainReportDeatilData.income}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='经营成本合计：' :label-width='120'>
                            <div>{{chainReportDeatilData.cost}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='本月经营利润：' :label-width='120'>
                            <div>{{chainReportDeatilData.profit}}</div>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span='8'>
                        <FormItem prop='' label='审核状态：' :label-width='120'>
                            <div>{{['未审核','已审核'][chainReportDeatilData.state]}}</div>
                        </FormItem>
                    </Col>
                    <Col span='3' offset="0" v-if="!chainReportDeatilData.state">
                        <FormItem>
                            <Button type='warning'  @click='getAudit' style="width: 120px">审核</Button>
                        </FormItem>
                    </Col>
                    <Col span='3' v-if="!chainReportDeatilData.state">
                        <FormItem>
                            <Button type='primary' @click='getSystemData' style="width: 120px">获取系统数据</Button>
                        </FormItem>
                    </Col>
                    <Col span='3'>
                        <FormItem>
                            <Button type='primary' @click='exportTable' style="width: 120px" :loading="this.exportBtn">导出明细表</Button>
                        </FormItem>
                    </Col>
                    <Col span='3'>
                        <FormItem>
                            <Button type='primary' @click='openContral' style="width: 120px">操作记录</Button>
                        </FormItem>
                    </Col>
                </Row>
                
                <!-- 第一个数组数据 -->
                <div class='page-title'>
                    <span>{{this.chainReportDeatilData.categorys[0].categoryName}}</span>
                </div>
                <Row>
                    <Col span='8'>
                        <FormItem prop='' label='房间数：' :label-width='120'>
                            <div>{{this.chainReportDeatilData.categorys[0].items[0].itemValue}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='可售房晚：' :label-width='120'>
                            <div>{{this.chainReportDeatilData.categorys[0].items[1].itemValue}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='出租房晚：' :label-width='120'>
                            <div>{{this.chainReportDeatilData.categorys[0].items[2].itemValue}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='出租率：' :label-width='120'>
                            <div>{{this.chainReportDeatilData.categorys[0].items[3].itemValue}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='平均房间ADR：' :label-width='120'>
                            <div>{{this.chainReportDeatilData.categorys[0].items[4].itemValue}}</div>
                        </FormItem>
                    </Col>
                    <Col span='8'>
                        <FormItem prop='' label='单房收入Revpar：' :label-width='160'>
                            <div>{{this.chainReportDeatilData.categorys[0].items[5].itemValue}}</div>
                        </FormItem>
                    </Col>
                </Row>

                <!-- 第二个数组数据  经营收入-->
                <div class='page-title'>
                    <span>经营收入</span>
                    <p style="
                    font-size: 14px;
                    color: red;
                    font-weight: bold;">收入请填入正数</p>
                </div>
                <Row type="flex" v-if="this.chainReportDeatilData.state === 0">
                    <Col span='12' offset="3">
                        <Button v-if="!this.tab.tabInDisable" type="primary" @click="saveChainReportDeatilDataIn(chainReportDeatilData.id, chainReportDeatilData.categorys[1].categoryName)" >保存</Button>
                        <Button type="info" @click="changeTab(chainReportDeatilData.categorys[1].categoryOrder, tab.tabInDisable)">     
                            <span v-if="this.tab.tabInDisable">编辑</span>
                            <span v-else>取消</span>
                        </Button>
                    </Col> 
                </Row>
                <br>
                <Row v-for="(item, index) in chainReportDeatilData.categorys[1].items" :key="item.itemName+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">{{item.itemName}}</Col>
                    <Col span="5">
                        <!-- <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeForInput(index, chainReportDeatilData.categorys[1].categoryOrder, chainReportDeatilData.categorys[1].categoryName)" v-model="item.itemValue" type="number"></InputNumber> -->
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabInDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[1].categoryOrder, chainReportDeatilData.categorys[1].categoryName)" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px; background-color: #ffffff;" :disabled="tab.tabInDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[1].categoryOrder, chainReportDeatilData.categorys[1].categoryName)" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="item.itemName==='其它支出' && !tab.tabInDisable" @click="deleteItem(chainReportDeatilData.id, item.itemId, item.itemName, item.itemValue, chainReportDeatilData.categorys[1].categoryName)" >删除</Button>  
                    </Col>
                </Row>
                <br>
                
                <!-- 第三个 经营成本 - 日常运营支出 -->
                <div class='page-title'>
                    <span>经营成本</span>
                    <p style="
                    font-size: 14px;
                    color: red;
                    font-weight: bold;">支出请填入负数</p>
                </div>
                <Row type="flex" align="middle">
                    <Col span="3" style="text-align: left; font-size:18px; font-weight:bold">{{chainReportDeatilData.categorys[2].categoryName}}</Col>
                    <Col span="6" style="text-align: left" v-if="this.chainReportDeatilData.state === 0">
                        <Button v-if="!this.tab.tabDayCostDisable" type="primary" @click="savechainReportDeatilDataDayCost(chainReportDeatilData.id, chainReportDeatilData.categorys[2].categoryName)">保存</Button>
                        <Button type="info" @click="changeTab(chainReportDeatilData.categorys[2].categoryOrder, tab.tabDayCostDisable)" >
                            <span v-if="this.tab.tabDayCostDisable">编辑</span>
                            <span v-else>取消</span>
                        </Button> 
                    </Col>
                </Row>
                <br>
                <Row v-for="(item, index) in chainReportDeatilData.categorys[2].items" :key="item.itemName+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">{{item.itemName}}</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabDayCostDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[2].categoryOrder, chainReportDeatilData.categorys[2].categoryName)" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabDayCostDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[2].categoryOrder, chainReportDeatilData.categorys[2].categoryName)" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="item.itemName==='其它支出' && !tab.tabDayCostDisable" @click="deleteItem(chainReportDeatilData.id, item.itemId, item.itemName, item.itemValue, chainReportDeatilData.categorys[2].categoryName)" >删除</Button>  
                    </Col>
                </Row>
                <!-- 添加(动态添加) -->
                <Row v-for="(item, index) in this.addItemsParmasForDay" :key="'日常运营其他支出'+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">其它支出</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabDayCostDisable" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabDayCostDisable"  maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="!tab.tabDayCostDisable" @click="deleteItemsOfMethod(chainReportDeatilData.categorys[2].categoryOrder, index)" >删除</Button>  
                    </Col>
                </Row>
                <Row type="flex" align="middle" style="marginTop:15px">
                    <Col span='12' offset="3">
                        <Button type="primary" @click="addItemsOfMethod(chainReportDeatilData.categorys[2].categoryOrder)" v-if="!tab.tabDayCostDisable">添加</Button>
                    </Col>
                </Row>
                
                
                <!-- 第四个 维护费用 - 日常运营支出 -->
                <br>
                <hr align=center size=0.5>
                <br>
                <Row type="flex" align="middle">
                    <Col span="3" style="text-align: left; font-size:18px; font-weight:bold">{{chainReportDeatilData.categorys[3].categoryName}}</Col>
                    <Col span="6" style="text-align: left" v-if="this.chainReportDeatilData.state === 0">
                        <Button v-if="!this.tab.tabProtectorCostDisable" type="primary" @click="savechainReportDeatilForprote(chainReportDeatilData.id, chainReportDeatilData.categorys[3].categoryName)">保存</Button>
                        <Button type="info" @click="changeTab(chainReportDeatilData.categorys[3].categoryOrder, tab.tabProtectorCostDisable)" >
                            <span v-if="this.tab.tabProtectorCostDisable">编辑</span>
                            <span v-else>取消</span>
                        </Button> 
                    </Col>
                </Row>
                <br>
                <Row v-for="(item, index) in chainReportDeatilData.categorys[3].items" :key="item.itemName+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">{{item.itemName}}</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabProtectorCostDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[3].categoryOrder, chainReportDeatilData.categorys[3].categoryName)" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabProtectorCostDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[3].categoryOrder,chainReportDeatilData.categorys[3].categoryName)" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="item.itemName==='其它支出' && !tab.tabProtectorCostDisable" @click="deleteItem(chainReportDeatilData.id, item.itemId, item.itemName, item.itemValue, chainReportDeatilData.categorys[3].categoryName)" >删除</Button>  
                    </Col>
                </Row>
                <!-- 添加(动态添加) -->
                <Row v-for="(item, index) in this.addItemsParmasForprote" :key="index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">其它支出</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabProtectorCostDisable" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabProtectorCostDisable" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="!tab.tabProtectorCostDisable" @click="deleteItemsOfMethod(chainReportDeatilData.categorys[3].categoryOrder, index)" >删除</Button>  
                    </Col>
                </Row>
                <Row type="flex" align="middle" style="marginTop:15px">
                    <Col span='12' offset="3">
                        <Button type="primary" @click="addItemsOfMethod(chainReportDeatilData.categorys[3].categoryOrder)" v-if="!tab.tabProtectorCostDisable">添加</Button>
                    </Col>
                </Row>


                <!-- 第五个 销售费用  -->
                <br>
                <hr align=center size=0.5>
                <br>
                <Row type="flex" align="middle">
                    <Col span="3" style="text-align: left; font-size:18px; font-weight:bold">{{chainReportDeatilData.categorys[4].categoryName}}</Col>
                    <Col span="6" style="text-align: left" v-if="this.chainReportDeatilData.state === 0">
                        <Button v-if="!this.tab.tabSellDisable" type="primary" @click="savechainReportDeatilForSell(chainReportDeatilData.id, chainReportDeatilData.categorys[4].categoryName)">保存</Button>
                        <Button type="info" @click="changeTab(chainReportDeatilData.categorys[4].categoryOrder, tab.tabSellDisable)" >
                            <span v-if="this.tab.tabSellDisable">编辑</span>
                            <span v-else>取消</span>
                        </Button> 
                    </Col>
                </Row>
                <br>
                <Row v-for="(item, index) in chainReportDeatilData.categorys[4].items" :key="item.itemName+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">{{item.itemName}}</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabSellDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[4].categoryOrder, chainReportDeatilData.categorys[4].categoryName)" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabSellDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[4].categoryOrder,chainReportDeatilData.categorys[4].categoryName)" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="item.itemName==='其它支出' && !tab.tabSellDisable" @click="deleteItem(chainReportDeatilData.id, item.itemId, item.itemName, item.itemValue, chainReportDeatilData.categorys[4].categoryName)" >删除</Button>  
                    </Col>
                </Row>
                <!-- 添加(动态添加) -->
                <Row v-for="(item, index) in this.addItemsParmasForSell" :key="index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">其它支出</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" :disabled="tab.tabSellDisable" type="number"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabSellDisable" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="!tab.tabSellDisable" @click="deleteItemsOfMethod(chainReportDeatilData.categorys[4].categoryOrder, index)" >删除</Button>  
                    </Col>
                </Row>
                <Row type="flex" align="middle" style="marginTop:15px">
                    <Col span='12' offset="3">
                        <Button type="primary" @click="addItemsOfMethod(chainReportDeatilData.categorys[4].categoryOrder)" v-if="!tab.tabSellDisable">添加</Button>
                    </Col>
                </Row>


                <!-- 第六个 管理费用  -->
                <br>
                <hr align=center size=0.5>
                <br>
                <Row type="flex" align="middle">
                    <Col span="3" style="text-align: left; font-size:18px; font-weight:bold">{{chainReportDeatilData.categorys[5].categoryName}}</Col>
                    <Col span="6" style="text-align: left" v-if="this.chainReportDeatilData.state === 0">
                        <Button v-if="!this.tab.tabManageDisable" type="primary" @click="savechainReportDeatilForManage(chainReportDeatilData.id, chainReportDeatilData.categorys[5].categoryName)">保存</Button>
                        <Button type="info" @click="changeTab(chainReportDeatilData.categorys[5].categoryOrder, tab.tabManageDisable)" >
                            <span v-if="this.tab.tabManageDisable">编辑</span>
                            <span v-else>取消</span>
                        </Button> 
                    </Col>
                </Row>
                <br>
                <Row v-for="(item, index) in chainReportDeatilData.categorys[5].items" :key="item.itemName+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">{{item.itemName}}</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值"  type="number" :disabled="tab.tabManageDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[5].categoryOrder, chainReportDeatilData.categorys[5].categoryName)"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabManageDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[5].categoryOrder,chainReportDeatilData.categorys[5].categoryName)" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="item.itemName==='其它支出' && !tab.tabManageDisable" @click="deleteItem(chainReportDeatilData.id, item.itemId, item.itemName, item.itemValue, chainReportDeatilData.categorys[5].categoryName)" >删除</Button>  
                    </Col>
                </Row>
                <!-- 添加(动态添加) -->
                <Row v-for="(item, index) in this.addItemsParmasForManage" :key="index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">其它支出</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" type="number" :disabled="tab.tabManageDisable" ></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabManageDisable" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="!tab.tabManageDisable" @click="deleteItemsOfMethod(chainReportDeatilData.categorys[5].categoryOrder, index)" >删除</Button>  
                    </Col>
                </Row>
                <Row type="flex" align="middle" style="marginTop:15px">
                    <Col span='12' offset="3">
                        <Button type="primary" @click="addItemsOfMethod(chainReportDeatilData.categorys[5].categoryOrder)" v-if="!tab.tabManageDisable">添加</Button>
                    </Col>
                </Row>





                <!-- 第七个 其他成本支出  -->
                <br>
                <hr align=center size=0.5>
                <br>
                <Row type="flex" align="middle">
                    <Col span="3" style="text-align: left; font-size:18px; font-weight:bold">{{chainReportDeatilData.categorys[6].categoryName}}</Col>
                    <Col span="6" style="text-align: left" v-if="this.chainReportDeatilData.state === 0">
                        <Button v-if="!this.tab.tabOtherDisable" type="primary" @click="savechainReportDeatilForOther(chainReportDeatilData.id, chainReportDeatilData.categorys[6].categoryName)">保存</Button>
                        <Button type="info" @click="changeTab(chainReportDeatilData.categorys[6].categoryOrder, tab.tabOtherDisable)" >
                            <span v-if="this.tab.tabOtherDisable">编辑</span>
                            <span v-else>取消</span>
                        </Button> 
                    </Col>
                </Row>
                <br>
                <Row v-for="(item, index) in chainReportDeatilData.categorys[6].items" :key="item.itemName+index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">{{item.itemName}}</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" type="number" :disabled="tab.tabOtherDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[6].categoryOrder, chainReportDeatilData.categorys[6].categoryName)"></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabOtherDisable" @on-change="changeForInput(index, chainReportDeatilData.categorys[6].categoryOrder,chainReportDeatilData.categorys[6].categoryName)" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="item.itemName==='其它支出' && !tab.tabOtherDisable" @click="deleteItem(chainReportDeatilData.id, item.itemId, item.itemName, item.itemValue, chainReportDeatilData.categorys[6].categoryName)" >删除</Button>  
                    </Col>
                </Row>
                <!-- 添加(动态添加) -->
                <Row v-for="(item, index) in this.addItemsParmasForOther" :key="index" type="flex" align="middle" style="marginTop:15px">
                    <Col span="3" style="text-align: center">其它支出</Col>
                    <Col span="5">
                        <Input v-model="item.itemValue" placeholder="请输入数值" type="number" :disabled="tab.tabOtherDisable" ></Input>
                    </Col>
                    <Col span="2" style="text-align: center">备注: </Col>
                    <Col span="11">
                        <Input v-model="item.remark" placeholder="此处填入备注" style="width: 500px" :disabled="tab.tabOtherDisable" maxlength="50" show-word-limit type="text"></Input>
                    </Col>
                    <Col span='3'>
                        <Button type="error" v-if="!tab.tabOtherDisable" @click="deleteItemsOfMethod(chainReportDeatilData.categorys[6].categoryOrder, index)" >删除</Button>  
                    </Col>
                </Row>
                <Row type="flex" align="middle" style="marginTop:15px">
                    <Col span='12' offset="3">
                        <Button type="primary" @click="addItemsOfMethod(chainReportDeatilData.categorys[6].categoryOrder)" v-if="!tab.tabOtherDisable">添加</Button>
                    </Col>
                </Row>
            </Form>
        </section>
        <!-- @on-ok="cancelContral"  -->
        <Modal
            v-model="isContralShow"
            title="操作记录"
            okText="关闭"
            cancelText=""
            > 
            <div v-for='item of controlHistory' :key='item.id' class='contralStyle'>
                <div class='control-left'>{{timeFormat(item.ctime)}}</div>
                <div class='control-right'>
                    <dl v-html="item.content">
                        {{item.content}}
                    </dl>
                    <!-- <v-html>操作：{{item.content}}</v-html> -->
                    <p>操作人：{{item.operatorName}}</p>
                </div>
            </div>
        </Modal>
    </article>
</template>
<script>
import Utils from "../../../utils";
import API from "../../../api";
import Moment from 'moment';
import Config from "@/config";

export default{
   
    created(){
        

        this.token = Utils.findFromLocalStorage('vue-token');
        this.env = Utils.findFromLocalStorage('env','dev');
        this.username = Utils.findFromLocalStorage("vue-username");
        this.userId = Utils.findFromLocalStorage('vue-userid');
        if(!Utils.hasPermission('Elong_elongOrderDetail_CancelOrder')){
            this.isShowCancelBtn = false;
        }
        this.apiHeaders = {
            'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
            'Authorization': Utils.findFromLocalStorage("Author-token"), //走阿里云需要
            'isForm': true //测试
        }
    },
    async mounted(){
       this.getExportChainDeatil(false);
    },
    data(){
        return{
            exportBtn: false,

            // 经营收入Tab
            tab:{
                tabInDisable: true,
                // 日常运营支出
                tabDayCostDisable: true,
                // 维护费用
                tabProtectorCostDisable: true,
                // 销售费用
                tabSellDisable: true,
                // 管理费用
                tabManageDisable: true,
                // 其他成本支出
                tabOtherDisable: true,
            },
            // 临时
            addItemsParmasForDay:[], // 日常运营支出
            addItemsParmasForprote:[], // 维护费用
            addItemsParmasForSell:[], // 销售费用
            addItemsParmasForManage:[], // 管理水平
            addItemsParmasForOther:[],
            // 更新
            updateItemsParmas:[],

            // 详细数据
            chainReportDeatilData: {
                categorys:[{
                    categoryName:'',
                    items:[]
                }]
            },
            isContralShow:false,  // 是否展示操作记录弹窗
            controlHistory: [],     // 操作记录
        }
    },
    methods:{
        // 打开操作记录弹出层
        async openContral(){
            this.isContralShow = true;
            this.getContral();
        },

        // 经营收入 
        saveChainReportDeatilDataIn(detailID, categoryName){

            let DataIn = []
            if (!this.checkNum(DataIn)) {
                return
            }

            this.tab.tabInDisable = !this.tab.tabInDisable
            this.updateItemsOfMethod(detailID, DataIn, categoryName)
        },

        // 日常运营支出
        savechainReportDeatilDataDayCost(detailID, categoryName){
            this.handleArr()
            if (!this.checkNum(this.addItemsParmasForDay)) {
                return
            }

            this.tab.tabDayCostDisable = !this.tab.tabDayCostDisable
            this.updateItemsOfMethod(detailID, this.addItemsParmasForDay, categoryName)
        },

        // 维护费用
        savechainReportDeatilForprote(detailID, categoryName){
            if (!this.checkNum(this.addItemsParmasForprote)) {
                return
            }
            this.tab.tabProtectorCostDisable = !this.tab.tabProtectorCostDisable
            this.updateItemsOfMethod(detailID, this.addItemsParmasForprote, categoryName)
        },

        // 销售费用
        savechainReportDeatilForSell(detailID, categoryName){
            if (!this.checkNum(this.addItemsParmasForSell)) {
                return
            }
            this.tab.tabSellDisable = !this.tab.tabSellDisable
            this.updateItemsOfMethod(detailID, this.addItemsParmasForSell, categoryName)
        },


        // 管理费用
        savechainReportDeatilForManage(detailID, categoryName){
            if (!this.checkNum(this.addItemsParmasForManage)) {
                return
            }
            this.tab.tabManageDisable = !this.tab.tabManageDisable
            this.updateItemsOfMethod(detailID, this.addItemsParmasForManage, categoryName)
        },


        // 其他成本支出
        savechainReportDeatilForOther(detailID, categoryName){
            if (!this.checkNum(this.addItemsParmasForOther)) {
                return
            }
            this.tab.tabOtherDisable = !this.tab.tabOtherDisable
            this.updateItemsOfMethod(detailID, this.addItemsParmasForOther, categoryName)
        },



        changeTab(categoryOrder, isBool){
            if ( !Utils.hasPermission( 'profitEdit' ) ) {
                this.$Notice.error( {
                    title: "无权限操作"
                } );
                return
            }



            if ((this.addItemsParmasForDay.length > 0 || this.updateItemsParmas.length > 0 || this.addItemsParmasForprote.length > 0 || this.addItemsParmasForSell.length > 0 || this.addItemsParmasForManage.length > 0 || this.addItemsParmasForOther.length > 0) && isBool === true) {
                alert('请先保存已修改的信息\n否则已修改的信息将会丢失')
                return
            } 
            this.tab.tabInDisable = true
            this.tab.tabDayCostDisable = true
            this.tab.tabProtectorCostDisable = true
            this.tab.tabSellDisable = true
            this.tab.tabManageDisable = true
            this.tab.tabOtherDisable = true

            if (categoryOrder === 4) { // 维护费用
                this.tab.tabProtectorCostDisable = !isBool
            }else if (categoryOrder === 3) { // 日常运营支出
                this.tab.tabDayCostDisable = !isBool
            }else if (categoryOrder === 2) { // 经营收入
                this.tab.tabInDisable = !isBool
            }else if (categoryOrder === 5) { // 销售费用
                this.tab.tabSellDisable = !isBool
            }else if (categoryOrder === 6) { // 管理费用
                this.tab.tabManageDisable = !isBool
            }else if (categoryOrder === 7) { // 其他成本支出
                this.tab.tabOtherDisable = !isBool
            }

            this.getPrpreferStaut()
        },
        // 缓存状态的增加条数
        addItemsOfMethod(categoryOrder){ 

            let addParam = { }
            if (categoryOrder === 4) { // 维护费用
                this.addItemsParmasForprote.push( addParam )
            }else if (categoryOrder === 3) { // 日常运营支出
                this.addItemsParmasForDay.push( addParam )
            }else if (categoryOrder === 5) { // 销售费用
                this.addItemsParmasForSell.push( addParam )
            }else if (categoryOrder === 6) { // 管理费用
                this.addItemsParmasForManage.push( addParam )
            }else if (categoryOrder === 7) { // 其他成本支出
                this.addItemsParmasForOther.push( addParam )
            }
        },
        updateItemsOfMethod(detailID, addItems, categoryName){
            let addParams = []
            for (let index = 0; index < addItems.length; index++) {
                const e =  addItems[index];
                addParams.push({
                    itemName: '其它支出',
                    itemValue: e.itemValue,
                    categoryName: categoryName,
                    remark: e.remark,
                }); // 增加的itemName 一定是其它支出
            }

            // update
            var queryParam = {
                id: detailID,
                updateItems: this.updateItemsParmas,
                addItems: addParams,
            }
            this.updateChainProfitMonthList(queryParam)
        },
        deleteItemsOfMethod(categoryOrder, index){ // 删除
        
            if (categoryOrder === 4) { // 维护费用
                this.addItemsParmasForprote.splice(index, 1);
            }else if (categoryOrder === 3) { // 日常运营支出
                this.addItemsParmasForDay.splice(index, 1);
            }else if (categoryOrder === 5) { // 销售费用
                this.addItemsParmasForSell.splice(index, 1);
            }else if (categoryOrder === 6) { // 管理费用
                this.addItemsParmasForManage.splice(index, 1);
            }else if (categoryOrder === 7) { // 其他成本支出
                this.addItemsParmasForOther.splice(index, 1);
            }
            
        },
        changeForInput(index, categoryOrder, categoryName){ // 更新的
        const citem  = this.chainReportDeatilData.categorys[categoryOrder-1].items[index]
        const citemId = citem.itemId

        let itemParam = { 
            itemId: citemId,
            itemName: citem.itemName,
            itemValue: citem.itemValue,
            categoryName: categoryName,
            remark: citem.remark,
        }
        this.updateItemsParmas.push( itemParam );
        console.log(this.updateItemsParmas)
        },

        // 删除Item - (删除设计成一个一个删除)
        deleteItem(detailID, itemID, itemName, itemValue, categroyName){
            var updateParam = {
                id: detailID,
                deleteItems: [{
                    categoryName: categroyName,
                    itemId: itemID,
                    itemName: itemName,
                    itemValue: itemValue,
                }],
            }
            this.updateChainProfitMonthList(updateParam)
            this.getExportChainDeatil(false)
        },

        // 清空数组, 获取最初状态
        getPrpreferStaut(){
            this.addItemsParmasForDay = [] 
            this.addItemsParmasForprote = []
            this.addItemsParmasForSell = []
            this.addItemsParmasForManage = []
            this.addItemsParmasForOther = []
            this.updateItemsParmas = []
            this.getExportChainDeatil(false)
        },

        checkNum(addItems){
            for (let index = 0; index < addItems.length; index++) {
                const e =  addItems[index];
                let f = parseFloat(e.itemValue)
                let arrsplit = e.itemValue.toString().split(".")
                if(arrsplit.length === 2 && e.itemValue.toString().split(".")[1].length > 2){
                    this.$Notice.error( {
                            title: "系统提示",
                            desc: e.itemName+"\n金额只能保存到分"
                        } );
                    return false;
                }
                if (f > 99999999.99){
                    this.$Notice.error( {
                            title: "系统提示",
                            desc: e.itemName+"\n金额输入错误系统限制, 请修改"
                        } );
                    return false;
                }
                if (f < -99999999.99){
                    this.$Notice.error( {
                        title: "系统提示",
                        desc: e.itemName+"\n金额输入错误系统限制, 请修改"
                    } );
                    return false;
                }
            }
            let upArr = this.updateItemsParmas;
            for (let index = 0; index < upArr.length; index++) {
                const e =  upArr[index];
                let f = parseFloat(e.itemValue)
                let arrsplit = e.itemValue.toString().split(".")
                if(arrsplit.length === 2 && e.itemValue.toString().split(".")[1].length > 2){
                    this.$Notice.error( {
                            title: "系统提示",
                            desc: e.itemName+"\n金额只能保存到分"
                        } );
                    return false;
                }
               if (f > 99999999.99){
                    this.$Notice.error( {
                            title: "系统提示",
                            desc: e.itemName+"\n金额不能大于\n99999999.99"
                        } );
                    return false;
                }
                if (f < -99999999.99){
                    this.$Notice.error( {
                        title: "系统提示",
                        desc: e.itemName+"金额不能小于-99999999.99"
                    } );
                    return false;
                }
            }
            return true;
        },

        // 处理数组去重问题
        handleArr(){
            // 先将缓存update数组去重
            var hash = {};
            this.updateItemsParmas = this.updateItemsParmas.reverse().reduce(function(item, next) {
                hash[next.itemId] ? '' : hash[next.itemId] = true && item.push(next);
                return item
            }, [])
        },
        
        // 更新明细
        async updateChainProfitMonthList(params){
            let resp = (await API.omsAPI[this.env].accountServer.postUpdateChainProfitMonthList(params, this.apiHeaders)).data
            this.getPrpreferStaut() //更新成功在刷新状态
            if ( resp.retCode ) {
				this.$Notice.error( {
					title: "更新失败",
					desc: resp.msg
				} );
				return;
            }
        },

        // 获取门店经营利润明细
        async getExportChainDeatil(isLodding){
            // let respData = (await API.omsAPI[this.env].elong.elongOrderDetail(orderId,this.token)).data;
            let chainID = Utils.getUrlParameterByName('chainID');
            this.chainID = chainID;
            if(isLodding){ this.$Spin.show() }
            let resp = ( await API.omsAPI[this.env].accountServer.getExportChainDeatil(chainID, this.apiHeaders));
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return;
            }
            this.chainReportDeatilData = resp.data 
            if(isLodding){ 
                this.$Spin.hide()
                this.$Notice.success({
                title: "获取系统数据成功"
                })
            }
        },

        // 获取操作记录
        async getContral(){
            let logParams = {
                outId: this.chainReportDeatilData.id,
                operationType: 5
            }
            let respData = (await API.omsAPI[this.env].accountServer.getOperationLogList(logParams, this.apiHeaders)).data;
            this.controlHistory = respData;
        },

        // 审核
        getAudit(){
            if ( !Utils.hasPermission( 'profitReview' ) ) {
                this.$Notice.error( {
                    title: "无权限操作"
                } );
                return
            }
            this.$Modal.confirm({
                title:'审核后无法再次修改数据',
                content: `确认通过审核？`,
                okText:'确定',
                cancelText:'取消',
                onOk:()=>{
                    this.$Spin.show()
                    let auditParams = {
                        id: this.chainReportDeatilData.id
                    }
                    let respData = (API.omsAPI[this.env].accountServer.postProfitMonthVerifiedForID(auditParams, this.apiHeaders))
                    if ( respData.retCode ) {
                        this.$Notice.error( {
                        title: "审核失败",
                        desc: respData.msg
                        });
                        return
                    }
                    this.$Spin.hide()
                    this.chainReportDeatilData.state = 1
                }
            })

        },

        // 获取系统数据
        async getSystemData(){
            if (this.addItemsParmasForDay.length > 0 || this.updateItemsParmas.length > 0 || this.addItemsParmasForprote.length > 0 || this.addItemsParmasForSell.length > 0 || this.addItemsParmasForManage.length > 0 || this.addItemsParmasForOther.length > 0) {
                alert('请先保存已修改的信息\n否则已修改的信息将会丢失')
                return
            } 
            let chainID = Utils.getUrlParameterByName('chainID');
            this.chainID = chainID;
            this.$Spin.show()
            let resp = ( await API.omsAPI[this.env].accountServer.getExportChainDeatilForRefresh(chainID, this.apiHeaders));
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return;
            }
            this.chainReportDeatilData = resp.data 
            this.$Spin.hide()
            this.$Notice.success({
                title: "获取系统数据成功"
            })
        },


        // 明细导出
        exportTable(){
            // if (!Utils.hasPermission('excel_exportCleanBillList')) {
			// 	this.$Notice.error( {
			// 		title: "无权限操作"
			// 	})
			// 	return
			// }
            let exportUrl = Config[this.env].clientServerUrl.accountAli + "profitMonth/export/" + this.chainReportDeatilData.id
            let xlsName = this.chainReportDeatilData.chainName + "经营利润明细"
            Utils.exportAliExcelWeighting( exportUrl,  xlsName, this.apiHeaders, this.$Notice.error, this, "exportBtn")
        },

        // 时间格式化
        timeFormat(time){
            return Moment(time).format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>
<style>
.display-flex {
    display: flex;
    flex-direction: row;
}
.page-title{
    font-size: 20px;
    background-color: #ddd;
    padding: 10px;
    margin-bottom: 20px;
}
.contralStyle{
    width:100%;
    overflow: auto;
    display:flex;
}
.control-left{
    width: 35%;
    text-align: right;
}
.control-right{
    width: 65%;
    text-align: left;
    padding-left:10px;
}

/* .ivu-select {
    width: 200px;
  }
  button {
    margin-left: 20px;
  }
  .inline-width{
    width: 200px;
  } */

.ivu-input[disabled], fieldset[disabled] .ivu-input{
    background-color: #fdfcfc;
}

.ivu-input-number-disabled{
    width: 200px;
}
.ivu-input-number{
    width: 200px;
}

</style>




// WEBPACK FOOTER //
// src/pages/report/chain-report/chain-reportDetail.vue